// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendarNoteScreen {
  background-color: #f3f4f6;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  padding-top: 60px;
  min-height: calc(100vh - 70px);
}
.calendarNoteScreen .content {
  width: 99%;
  margin: auto;
}
.calendarNoteScreen .content .header {
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  position: relative;
  left: 3.3%;
  color: #333333;
}
.calendarNoteScreen .content .controllerRow {
  margin: auto;
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 93%;
  margin-bottom: 24px;
}
.calendarNoteScreen .content .controllerRow .leftPart {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/screens/calendarNote/calendarNote.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,8BAAA;AACJ;AAAI;EACI,UAAA;EACA,YAAA;AAER;AAAQ;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AAEZ;AAAQ;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,mBAAA;AAEZ;AAAY;EACI,aAAA;AAEhB","sourcesContent":[".calendarNoteScreen {\n    background-color: #f3f4f6;\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    padding-top: 60px;\n    min-height: calc(100vh - 70px);\n    .content {\n        width: 99%;\n        margin: auto;\n\n        .header {\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            position: relative;\n            left: 3.3%;\n            color: #333333;\n        }\n        .controllerRow {\n            margin: auto;\n            margin-top: 16px;\n            display: flex;\n            flex-direction: row;\n            justify-content: space-between;\n            width: 93%;\n            margin-bottom: 24px;\n\n            .leftPart {\n                display: flex;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
